import BackgroundColors from '@root/joinroot.com/src/utils/background-colors';
import LinkButton from '@root/joinroot.com/src/components/buttons/link-button';
import PropTypes from '@root/vendor/prop-types';
import Responsive from '@root/core/src/utils/responsive';
import { Eyebrow, H1Display, Subhead } from '@root/joinroot.com/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';
import { TEXT_ALIGNMENT_OPTIONS } from '@root/joinroot.com/src/constants/constants';

export default function HeroImageNone({
  anchor,
  textAlignment = TEXT_ALIGNMENT_OPTIONS.CENTER,
  buttons,
  eyebrow,
  headline,
  subhead,
  form,
  backgroundColor = BackgroundColors.cmsValues.WHITE,
  buttonComponent = LinkButton,
}) {
  const ButtonComponent = buttonComponent;

  let renderButtons = false;
  let renderForm = false;

  if (buttons.length > 0) {
    renderButtons = true;
  } else if (form) {
    renderForm = true;
  }

  return (
    <section
      css={[
        stylesBase.heroSection,
        textAlignment === TEXT_ALIGNMENT_OPTIONS.LEFT && stylesAlignmentLeft.heroSection,
        BackgroundColors.getBackgroundStyle(backgroundColor),
      ]}
      id={anchor}
    >
      <div className={'wrap_content'}>
        <div className={'container_content'}>

          {eyebrow && <Eyebrow className={'eyebrow'}>{eyebrow}</Eyebrow>}
          {headline && <H1Display className={'headline'}>{headline}</H1Display>}
          {subhead && <Subhead className={'subhead'}>{subhead}</Subhead>}

          {renderButtons && (
            <div className={'container_cta'}>
              {buttons.map((btn, i) => (
                <ButtonComponent
                  buttonStyles={buttonStyles}
                  key={i}
                  onClick={btn.onClick}
                  to={btn.link}
                  type={btn.type}
                >
                  {btn.text}
                </ButtonComponent>
              ))}
            </div>
          )}

          {renderForm && form}
        </div>
      </div>
    </section>
  );
}

HeroImageNone.propTypes = {
  anchor: PropTypes.string,
  backgroundColor: PropTypes.oneOf(BackgroundColors.cmsValueList),
  buttonComponent: PropTypes.func,
  buttons: PropTypes.arrayOf(PropTypes.object),
  eyebrow: PropTypes.string,
  form: PropTypes.node,
  headline: PropTypes.string.isRequired,
  subhead: PropTypes.string,
  textAlignment: PropTypes.oneOf(Object.values(TEXT_ALIGNMENT_OPTIONS)),
};

const stylesAlignmentLeft = StyleSheet.create({
  heroSection: {

    '.wrap_content .container_content': {
      ...Responsive.md({
        alignItems: 'flex-start',
        textAlign: 'left',

        '.container_cta': {
          ...Responsive.md({
            justifyContent: 'flex-start',
          }),
        },
      }),
    },
  },
});

const stylesBase = StyleSheet.create({
  heroSection: {
    position: 'relative',
    backgroundColor: 'white',

    '.wrap_content': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      '.container_content': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: 1200,
        padding: '80px 20px',
        textAlign: 'center',

        ...Responsive.md({
          padding: '100px 20px',
        }),

        '.eyebrow': {
          maxWidth: 350,
        },

        '.headline, .subhead': {
          maxWidth: 550,

          ...Responsive.md({
            maxWidth: 800,
          }),
        },

        '.eyebrow, .headline, .subhead': {
          marginBottom: 12,
        },

        '.container_cta': {
          display: 'flex',
          flexDirection: 'column',
          margin: '30px -10px 0', // -10px accounts for margin on cta elements within.
          width: '100%',
          maxWidth: 260,

          ...Responsive.md({
            justifyContent: 'center',
            flexDirection: 'row',
            maxWidth: 480,
          }),
        },
      },
    },
  },
});

const buttonStyles = {
  margin: 10,
};
